import Collection from '../../utils/Collection';

import { LOGOUT } from '../../actions/auth';

import {
  RESET_UNSEEN_MESSAGE_COUNT_SENT,
  GET_UNSEEN_MESSAGE_COUNT_SUCCEEDED,
} from '../../actions/currentUser';

import {
  FETCH_CONVERSATIONS_SUCCEEDED,
  LOAD_MORE_CONVERSATIONS_SUCCEEDED,
} from '../../actions/conversation';

import {
  RECEIVED_NEW_MESSAGE,
  MARK_MESSAGE_READ_SENT,
} from '../../actions/message';

const initialState = {
  count: 0,
  unseenCountList: [],
};

const normalizeUnseenCount = (item) => {
  if (!item) return item;
  const rawId = typeof item.id !== 'undefined' ? item.id : item.conversation_id;
  if (typeof rawId === 'undefined') return item;
  const normalizedId = Number(rawId);
  if (Number.isNaN(normalizedId)) return item;
  return { ...item, id: normalizedId };
};

const normalizeUnseenCountList = (items = []) => {
  if (!items || items.length === 0) return [];
  return items.map(normalizeUnseenCount);
};

export default function unseenMessageCountReducer(
  state = initialState,
  action,
) {
  const { payload, type } = action;
  let uc;
  switch (type) {
    case LOGOUT:
      return initialState;
    case FETCH_CONVERSATIONS_SUCCEEDED:
    case LOAD_MORE_CONVERSATIONS_SUCCEEDED:
      return {
        ...state,
        unseenCountList: Collection.add(
          state.unseenCountList,
          normalizeUnseenCountList(payload.unseen_count_list),
        ),
      };
    case RECEIVED_NEW_MESSAGE: {
      const convoId = +payload.conversation.id;
      const existingUc = Collection.get(state.unseenCountList, convoId);
      // Clone the object to avoid state mutation
      uc = existingUc
        ? { ...existingUc, unseen_count: existingUc.unseen_count + 1 }
        : null;
      return {
        ...state,
        count: state.count + 1,
        unseenCountList: uc
          ? Collection.update(state.unseenCountList, convoId, uc)
          : state.unseenCountList,
      };
    }
    case RESET_UNSEEN_MESSAGE_COUNT_SENT:
      return {
        ...state,
        count: 0,
      };
    case MARK_MESSAGE_READ_SENT: {
      const convoId = Number(payload.conversationId);
      const existingUc = Collection.get(state.unseenCountList, convoId);
      if (existingUc) {
        // Clone the object to avoid state mutation
        const nextUnseenCount = Math.max(0, existingUc.unseen_count - 1);
        uc = { ...existingUc, unseen_count: nextUnseenCount };
        const shouldDecrementCount = nextUnseenCount < existingUc.unseen_count;
        const nextCount = shouldDecrementCount ? state.count - 1 : state.count;
        return {
          ...state,
          count: nextCount >= 0 ? nextCount : 0,
          unseenCountList: Collection.update(
            state.unseenCountList,
            convoId,
            uc,
          ),
        };
      } else {
        return state;
      }
    }
    case GET_UNSEEN_MESSAGE_COUNT_SUCCEEDED:
      return {
        ...state,
        count: payload.count,
      };
    default:
      return state;
  }
}
